// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const switchClasses = {
  control: "qui-switch__control",
  hiddenInput: "qui-switch__hidden-input",
  label: "qui-switch__label",
  root: "qui-switch__root",
  thumb: "qui-switch__thumb",
} as const
